import { z, isoZ } from 'my-zod'
import { PricingTierEnum } from './model-family-pricing-tier'
import { productLineOptions } from '../../internal/product-lines'
import { SalesQuoteSeasonTypeEnum } from '../../outfitter-account-management/sales-quote'
import { MarketingIconOptions } from './marketing-icons'

export const modelFamiliesModel = z.object({
  id: z.number(),
  modelFamilyName: z.string().nonempty(),
  marketingDisplayName: z.string().nullable().setLabel('ADV Marketing Display Name'),
  productLine: z.enum(productLineOptions).nullable(),
  seasonTypes: SalesQuoteSeasonTypeEnum.array().nullable(),
  pricingTier: PricingTierEnum.nullable(),
  modelFamilyImageUrl: z.string().nullable(),
  capacity: z.number().min(1),
  manuallyReviewed: z.boolean(),
  isAutoCreated: z.boolean().setLabel('Auto Created'),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable(),
  serverLastModifiedDate: isoZ.instant().nullable(),
  marketingShortDescription: z.string().max(250).nullable(),
  descriptorIcon1: z.enum(MarketingIconOptions).nullable(),
  descriptorIcon2: z.enum(MarketingIconOptions).nullable(),
  descriptionIcon1Text: z.string().max(50).nullable(),
  descriptionIcon2Text: z.string().max(50).nullable()
})

export type modelFamiliesModel = z.infer<typeof modelFamiliesModel>
